"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUpdateCustomerOrderItemErrorResponse = exports.UpdateCustomerOrderItemFailedEvent = exports.Name = void 0;
var _failedEventData = require("@ori-events/failed-event-data");
const Name = exports.Name = 'update-customer-order-item-failed';
const UpdateCustomerOrderItemFailedEvent = exports.UpdateCustomerOrderItemFailedEvent = Name;
const isUpdateCustomerOrderItemErrorResponse = response => (0, _failedEventData.isErrorResponse)(response);
exports.isUpdateCustomerOrderItemErrorResponse = isUpdateCustomerOrderItemErrorResponse;
